export { default } from './LoadingIcon'